import React from 'react'
import styled from '@emotion/styled'
import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from 'react-i18next'

import { CardContent, Grid, Card as MuiCard, Divider as MuiDivider, Typography } from '@mui/material'
import { spacing } from '@mui/system'

const Card = styled(MuiCard)(spacing)

const Divider = styled(MuiDivider)(spacing)

function EmptyCard() {
    const { t } = useTranslation()
    return (
        <Card mb={6}>
            <CardContent>
                <Typography variant='h6' gutterBottom>
                    {t('pages.reports.title')}
                </Typography>
                <Typography variant='body2' gutterBottom>
                    <p>
                        {t('pages.reports.contactPrefix')}
                        <a href='mailto:info@financelab.se'>info@financelab.se</a>
                        {t('pages.reports.contactSuffix')}
                    </p>
                </Typography>
            </CardContent>
        </Card>
    )
}

function Reports() {
    const { t } = useTranslation()
    return (
        <React.Fragment>
            <Helmet title={t('pages.reports.title')} />
            <Typography
                variant='h3'
                gutterBottom
                sx={{
                    display: 'inline',
                }}
            >
                {t('pages.reports.title')}
            </Typography>
            <Divider my={6} />
            <Grid container spacing={6}>
                <Grid size={12}>
                    <EmptyCard />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default Reports
